import { render } from "./Main.vue?vue&type=template&id=6101b340"
const script = {}
script.render = render

export default script